<template>
  <div class="content_main">
    <div class="bgOne" id="bgOne">
      <div class="centerOne">
        <div class="head">
          <div class="firmlogo">
            <div class="firmlogoright">
              <img src="../../assets/img/logo1.svg" alt="" />
            </div>
            <!-- 调取本地邮箱测试用 -->
            <!-- <a href=mailto:sample@163.com>send email</a> -->
          </div>
          <div class="topright">
            <div class="selectleft" id="router">
              <a
                :class="{ active: active === 3 }"
                @click="scrollTo(3)"
                href="javascript:void(0)"
                ><span class="onespan"> Services </span></a
              >


              <a
                :class="{ active: active === 4 }"
                @click="scrollTo(4)"
                href="javascript:void(0)"
                ><span class="onespan"> POD </span></a
              >
              <a
                  @click="product"
                  href="javascript:void(0)"
              ><span class="onespan"> Product </span></a
              >
              <a
                :class="{ active: active === 6 }"
                @click="
                  scrollTo(6);
                  changeShow6();
                "
                href="javascript:void(0)"
                ><span>Price</span></a
              >
              <a
                :class="{ active: active === 6 }"
                @click="
                  scrollTo(6);
                  changeShow8();
                "
                href="javascript:void(0)"
                ><span> Delivery Time</span></a
              >
              <a
                :class="{ active: active === 8 }"
                @click="scrollTo(8)"
                href="javascript:void(0)"
                ><span>Processing</span></a
              >
            </div>
            <div  @click="contact_us" class="selectright">
              <div><span>Contact Us Now</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgTwo">
      <div class="centerTwo">
        <div class="bodymainone">
          <div class="nick">
            <div class="titletop">
              <!-- vue里的过渡动画，用标签包着加上name属性绑定 -->
              <!-- <transition name="bounce"> -->
              <div class="titleleft" v-show="titleShow">
                <span class="titleone"> The All-In-One Dropshipping </span>
                <span class="middleOne"> Super </span>
                <span class="middleTwo"> Housekeeper </span>
                <span class="middleThree">
                  Stable / Reliable / Safe / Professional & Efficient
                </span>
              </div>
              <!-- </transition> -->
              <!-- vue里的过渡动画，用标签包着加上name属性绑定 -->
              <!-- <transition name="bounce"> -->
              <div class="titleright" v-show="titleShow">
                <div class="video">
                  <video
                    width="100%"
                    height="100%"
                    muted="muted"
                    controls
                    autoplay="autoplay"
                    loop="loop"
                    poster="../../assets/img/shiping1.svg"
                  >
                    <source
                      src="../../assets/video/video.mp4"
                      type="video/mp4"
                    />
                    <!-- <source src="movie.ogg" type="video/ogg">
                                        <source src="movie.webm" type="video/webm"> -->
                    <!-- 您的浏览器不支持 video 标签。 -->
                  </video>
                  <!-- <img src="../../assets/img/shiping1.svg" alt="" style="width:100%;height:100%"> -->
                </div>
              </div>
              <!-- </transition> -->
            </div>
            <!--wow.js库动画给类名加上 wow animate__animated animate__slideInUp，动画持续时间data-wow-duration="3s" -->
            <div class="titleBottom">
              <div class="subtitleOne">
                <div class="contentOne">
                  <span>Save your money</span>
                  <span
                    >We will source for you with lower price and high
                    quality.</span
                  >
                </div>
                <div class="imgOne">
                  <img src="../../assets/img/1-03.svg" alt="" />
                </div>
              </div>
              <div class="subtitleTwo">
                <div class="contentOne">
                  <span>Protect your store </span>
                  <span
                    >We are your stable partner, help you to control risks and
                    avoid buyers disputes.
                  </span>
                </div>
                <div class="imgTwo">
                  <img src="../../assets/img/1_huaban1.svg" alt="" />
                </div>
              </div>
              <div class="subtitleThree">
                <div class="contentOne">
                  <span>Grow your money </span>
                  <span
                    >We are your trust friend, share you the good secrets and
                    tips to grow your order sales.
                  </span>
                </div>
                <div class="imgThree">
                  <img src="../../assets/img/1-02.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgThree" id="bgThree">
      <div class="centeThree">
        <div class="chest">
          <div class="chestTop">
            <span> Plentiful, All-In-One Services </span>
          </div>
          <!-- <div class="chestButtom">
                        <div @mouseover="changeShow1"><span>General Services</span></div>
                        <div  @mouseover="changeShow2"><span>Pro Services</span></div>
                        <div  @mouseover="changeShow3"><span>Features-POD Services</span></div>
                    </div> -->
        </div>
      </div>
    </div>
    <div id="bgFour">
      <div class="centeFour">
        <div class="abdomen">
          <div class="abdomenTop">
            <div class="abdomenOne">
              <div class="imgOne">
                <img src="../../assets/img/1-04.svg" alt="" />
              </div>
              <!-- <div>01</div> -->
              <div>We Source For You</div>
            </div>
            <div class="abdomenTwo">
              <div class="imgTwo">
                <img src="../../assets/img/1-06.svg" alt="" />
              </div>
              <!-- <div>02</div> -->
              <div>We Purchase For you</div>
            </div>
            <div class="abdomenThree">
              <div class="imgThree">
                <img src="../../assets/img/1-05.svg" alt="" />
              </div>
              <!-- <div>03</div> -->
              <div>We Fulfill For You</div>
            </div>
          </div>
          <div class="abdomenMiddle">
            <div class="abdomenFour">
              <div class="imgFour">
                <img src="../../assets/img/1-07.svg" alt="" />
              </div>
              <!-- <div>04</div> -->
              <div>We Stock For You</div>
            </div>
            <div class="abdomenFive">
              <div class="imgFive">
                <img src="../../assets/img/1-08.svg" alt="" />
              </div>
              <!-- <div>05</div> -->
              <div>We Quality Check For You</div>
            </div>
            <div class="abdomenSix">
              <div class="imgSix">
                <img src="../../assets/img/1-09.svg" alt="" />
              </div>
              <!-- <div>06</div> -->
              <div>We Ship For You</div>
            </div>
          </div>
          <div class="abdomenButtom">
            <div class="abdomenSeven">
              <div class="imgSeven">
                <img src="../../assets/img/1-11.svg" alt="" />
              </div>
              <!-- <div>07</div> -->
              <div>We Optimize Shipping For You</div>
            </div>
            <div class="abdomenEight">
              <div class="imgEight">
                <img src="../../assets/img/1-10.svg" alt="" />
              </div>
              <!-- <div>08</div> -->
              <div>We Offer 24/7 service VIP customer manager</div>
            </div>
            <div class="abdomenNine">
              <div class="imgNine">
                <img src="../../assets/img/2-36.svg" alt="" />
              </div>
              <!-- <div>07</div> -->
              <div>
                Offer Payment Invoices & Parcel Delivery Successfully Proof
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="bgFour_two" v-if="show2">
            <div class="centeFour">
                <div class="abdomen">
                    <div class="abdomenTop">
                        <div class="abdomenOne">
                            <div class="imgOne">
                                <img src="../../assets/img/2-24.png" alt="">
                            </div>
                            
                            <div>Print On Demand</div>
                        </div>
                        <div class="abdomenTwo">
                            <div class="imgTwo">
                                <img src="../../assets/img/2-23.png" alt="">
                            </div>
                         
                            <div>Custom Packaging</div>
                        </div>
                      
                    </div>

                    <div class="abdomenButtom">
                        <div class="abdomenSeven">
                            <div class="imgSeven">
                                <img src="../../assets/img/2-22.png" alt="">
                            </div>
                           
                            <div>Engraved Logo  On Product</div>
                        </div>
                        <div class="abdomenEight">
                            <div class="imgEight">
                                <img src="../../assets/img/2-21.png" alt="">
                            </div>
                            <div>Custom Card And Label</div>
                        </div>
             

                    </div>
                </div>

            </div>
        </div>
        <div id="bgFour_three" v-if="show3">
            <div class="centeFour">
                <div class="abdomen">
                    <div class="abdomenTop">
                        <div class="abdomenOne">
                            <div class="imgOne">
                                <img src="../../assets/img/2-20.png" alt="">
                            </div>
                            <div>Print On Demand</div>
                        </div>
                        <div class="abdomenTwo">
                            <div class="imgTwo">
                                <img src="../../assets/img/2-19.png" alt="">
                            </div>
                            <div>Custom Packaging</div>
                        </div>
                      
                    </div>

                    <div class="abdomenButtom">
                        <div class="abdomenSeven">
                            <div class="imgSeven">
                                <img src="../../assets/img/2-11.png" alt="">
                            </div>
                            <div>Engraved Logo  On Product</div>
                        </div>
                        <div class="abdomenEight">
                            <div class="imgEight">
                                <img src="../../assets/img/2-16.png" alt="">
                            </div>
                            <div>Custom Card And Label</div>
                        </div>
                        <div class="abdomenNine">
                            <div class="imgEight">
                                <img src="../../assets/img/2-17.png" alt="">
                            </div>
                            <div>Custom Card And Label</div>
                        </div>
             

                    </div>
                </div>

            </div>
        </div> -->
    <!-- <router-view></router-view> -->
    <div class="bgFive">
      <div class="centeFive">
        <div class="thigh" id="bgFive">
          <div class="product_title1">Features Services-Print On Demand</div>
          <!--wow.js库动画给类名加上 wow animate__animated animate__fadeIn，动画持续时间data-wow-duration="3s" -->
          <div class="thighLeft" v-show="titleShow">
            <img src="../../assets/img/2-1.png" alt="" />
          </div>

          <div class="thighRight">
            <div class="thigh_content1">
              <div class="square">
                <!-- <img class="serve" src="../../assets/img/serve1.svg" alt=""> -->
                <div class="iconfont serve1">&#xe60c;</div>
              </div>
              <div class="small_content1">Print On Demand</div>
            </div>
            <div class="thigh_content1">
              <div class="square">
                <div class="iconfont serve1">&#xe610;</div>
              </div>
              <div class="small_content1">1 to 1 DIY Customization</div>
            </div>
            <div class="thigh_content1">
              <div class="square">
                <div class="iconfont serve1">&#xe60f;</div>
              </div>
              <div class="small_content1">Personalized Customization</div>
            </div>
            <div class="thigh_content1">
              <div class="square">
                <div class="iconfont serve1">&#xe60d;</div>
              </div>
              <div class="small_content1">Engraved brand Logo On Product</div>
            </div>
            <div class="thigh_content1">
              <div class="square">
                <div class="iconfont serve1">&#xe60e;</div>
              </div>
              <div class="small_content1">
                Custom Packaging, Card and Stickers
              </div>
            </div>
            <!-- <img src="@/assets/img/1-12.svg" alt=""> -->
          </div>
        </div>
      </div>
    </div>
    <div class="bgSix">
      <div class="centeSix">
        <div class="calf">
          <div class="calfTop">
            <div>Popular POD Products</div>
            <div class="calfTop_conten">
              Compared with general product, more sales! more profit!
            </div>
          </div>
          <div class="calfButtom">
            <div class="goods_top">
              <div class="goods_left">
                <div class="goods_title1">Phone Case</div>
                <div class="goods_one">
                  <img src="../../assets/img/2-2.png" alt="" />
                </div>
              </div>
              <div class="goods_middle">
                <div class="goods_two">
                  <div class="goods_two_left">
                    <div class="goods_title2">Wall Decoration</div>
                    <div class="goods_two_content">Canvas Painting Poster</div>
                  </div>
                  <div class="goods_two_right">
                    <img src="../../assets/img/2-3.png" alt="" />
                  </div>
                </div>
                <div class="goods_three">
                  <div class="goods_three_left">
                    <div class="goods_title3">Ball</div>
                    <div class="goods_three_content">Baseball</div>
                    <div class="goods_three_content">Basketball</div>
                    <div class="goods_three_content">Football</div>
                  </div>
                  <div class="goods_three_right">
                    <img src="../../assets/img/2-4.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="goods_right">
                <div class="goods_four_top">
                  <div class="goods_title4">Clothing</div>
                  <!-- <div class="goods_center4">Short sleeve </div> -->
                  <div class="goods_center4">Sweater</div>
                  <div class="goods_center4">T-shirt</div>
                  <div class="goods_center4">Sock</div>
                </div>

                <div class="goods_four">
                  <img src="../../assets/img/2-5.png" alt="" />
                </div>
              </div>
            </div>
            <div class="goods_middle">
              <div class="goods_middle_five">
                <div class="goods_five_left">
                  <div class="goods_five_title">Wooden product</div>
                  <div class="goods_five_content">Music Box Candlestick</div>
                </div>
                <div class="goods_five_right">
                  <img src="../../assets/img/2-7.png" alt="" />
                </div>
              </div>
              <div class="goods_middle_six">
                <div class="goods_six_left">
                  <div class="goods_six_title">Accessories</div>
                  <div class="goods_six_content">
                    Wallet Necklace Ring Bracelet
                  </div>
                </div>
                <div class="goods_six_right">
                  <img src="../../assets/img/2-6.png" alt="" />
                </div>
              </div>
            </div>

            <div class="goods_bottom">
              <div class="goods_bottom_seven">
                <div class="goods_seven_left">
                  <div class="goods_seven_title">3D Printing</div>
                </div>
                <div class="goods_seven_right">
                  <img src="../../assets/img/2-9.png" alt="" />
                </div>
              </div>
              <div class="goods_bottom_eight">
                <div class="goods_eight_left">
                  <div class="goods_eight_title">Household items</div>
                  <div class="goods_eight_content">Cup Pillowcase</div>
                </div>
                <div class="goods_eight_right">
                  <img src="../../assets/img/2-8.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgSeven" id="bgSeven">
      <div class="centeSeven">
        <div class="ankle">
          <div class="ankleTop">
            <span class="ankleTop_title">Why Choose Us？</span>
            <div class="ankleTop_contnt">
              We will take care of virtually everything for you?
            </div>
          </div>
          <div class="anklemiddle">
            <div
              class="anklemiddleOne anklemiddleOne1"
              @mousemove="changeShow4"
            >
              <div class="iconfont choose_icon">&#xe607;</div>
              <span>POD Equipment</span>
            </div>
            <!-- <div class="anklemiddleOne" @mousemove="changeShow5">
                            <div class="iconfont choose_icon" >&#xe601;</div>
                            <span>Service</span>
                        </div> -->
            <div class="anklemiddleOne" @mousemove="changeShow6">
              <div class="iconfont choose_icon">&#xe604;</div>
              <span>Price</span>
            </div>
            <div class="anklemiddleOne" @mousemove="changeShow7">
              <div class="iconfont choose_icon">&#xe608;</div>
              <span>Inventory</span>
            </div>
            <div class="anklemiddleOne" @mousemove="changeShow8">
              <div class="iconfont choose_icon">&#xe609;</div>
              <span>Shipping</span>
            </div>
            <!-- <div class="anklemiddleOne" @mousemove="changeShow9">
                            <div class="iconfont choose_icon">&#xe60a;</div>
                            <span>Technical</span>
                        </div> -->
            <div class="anklemiddleOne" @mousemove="changeShow10">
              <div class="iconfont choose_icon">&#xe60b;</div>
              <span>After Sales</span>
            </div>
          </div>
          <transition name="slide-fade">
            <div v-if="show4" id="ankleBottom_one" class="ankleBottom">
              <div class="choose_img_left choose_img_left1">
                <img src="../../assets/img/2-10.png" alt="" />
              </div>
              <div class="choose_content_right">
                <div class="content_title">Advanced POD Equipment</div>
                <!-- <div class="content_title2">24-hour billing number, 2-7 days after delivery</div> -->
                <div class="content_one">
                  <ul>
                    <li>The most advanced POD equipment in the world</li>
                    <li>The same equipment as the Nike factory</li>
                    <li>Meet all your customization requirements</li>
                    <!-- <li>No Hide Feey</li> -->
                  </ul>
                </div>
                <!-- <div class="content_two">
                                Compared with Aliexpress, we directly cooperate with factories without paying platform commissions, so the
                                price is more competitive and cheaper.
                            </div> -->
              </div>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="show5" id="ankleBottom_two" class="ankleBottom">
              <div class="choose_img_left">
                <img src="../../assets/img/2-37.jpg" alt="" />
              </div>
              <div class="choose_content_right">
                <div class="content_title">
                  Free one to one customer manager service
                </div>
                <div class="content_title2">
                  Your dropshipping business All-in one "private butler"
                </div>
                <div class="content_one">
                  <ul>
                    <li>Free product Sourcing</li>
                    <li>Purchasing products</li>
                    <li>Strict quality inspection</li>
                    <li>
                      Assist in inventory management and improve inventory
                      stability
                    </li>
                    <li>Ship to your customer</li>
                    <li>Help you to run your store Steadily and long-term</li>
                    <li>Store operation strategy tips sharing</li>
                  </ul>
                </div>
                <!-- <div class="content_two">
                                Compared with Aliexpress, we directly cooperate with factories without paying platform commissions, so the
                                price is more competitive and cheaper.
                            </div> -->
              </div>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="show6" id="ankleBottom_three" class="ankleBottom">
              <div class="choose_img_left">
                <img src="../../assets/img/2-38.svg" alt="" />
              </div>
              <div class="choose_content_right">
                <div class="content_title">Competitive Product Price</div>
                <!-- <div class="content_title2">24-hour billing number, 2-7 days after delivery</div> -->
                <div class="content_one">
                  <ul>
                    <li>No Setup Fee</li>
                    <li>No Monthly Fee</li>
                    <li>No Hidden Fee</li>
                    <li>So cheaper than AliExpress</li>
                  </ul>
                </div>
                <!-- <div class="content_two">
                                Compared with Aliexpress, we directly cooperate with factories without paying platform commissions, so the
                                price is more competitive and cheaper.
                            </div> -->
              </div>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="show7" id="ankleBottom_four" class="ankleBottom">
              <div class="choose_img_left">
                <img src="../../assets/img/2-39.svg" alt="" />
              </div>
              <div class="choose_content_right">
                <div class="content_title">"0" Inventory Risk</div>
                <!-- <div class="content_title2">Free your financial pressure and reduce inventory risk</div> -->
                <div class="content_one">
                  <ul>
                    <li>No Minimum Order</li>
                    <li>$0 warehouse storage fee</li>
                    <li>Open an online shop at zero cost</li>
                    <li>
                      Free your financial pressure & reduce inventory risk
                    </li>
                  </ul>
                </div>
                <!-- <div class="content_two">
                                Compared with Aliexpress, we directly cooperate with factories without paying platform commissions, so the
                                price is more competitive and cheaper.
                            </div> -->
              </div>
            </div>
          </transition>
          <transition name="slide-fade">
            <div
              v-if="show8"
              id="ankleBottom_five"
              class="ankleBottom ankleBottom_five"
            >
              <div class="choose_img_left">
                <img src="../../assets/img/2-40.svg" alt="" />
              </div>
              <div class="choose_content_right">
                <div class="content_title">Fast Processing & Shipping</div>
                <!-- <div class="content_title2">24-hour billing number, 2-7 days after delivery</div> -->
                <div class="content_one1">
                  <ul>
                    <li>Quickly response 24/7</li>
                    <li>Delivery 7 days or less</li>
                    <li>100% Auto-Process Orders</li>
                    <li>Overseas warehouse service</li>
                    <li>Full track and feedback after delivery</li>
                  </ul>
                </div>
                <!-- <div class="content_two">
                                Compared with Aliexpress, we directly cooperate with factories without paying platform commissions, so the price is more competitive and cheaper.
                            </div> -->
              </div>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="show9" id="ankleBottom_six" class="ankleBottom">
              <div class="choose_img_left">
                <img src="../../assets/img/2-41.jpg" alt="" />
              </div>
              <div class="choose_content_right">
                <div class="content_title">Strong technical support</div>
                <div class="content_title2">
                  Significantly reduce your workload
                </div>
                <!-- <div class="content_one">
                                <ul>
                                    <li>No Setup Fee</li>
                                    <li>No Monthly Fee</li>
                                    <li>No Minimum Order Quantity</li>
                                    <li>No Hide Feey</li>
                                </ul>
                            </div> -->
                <div class="content_two">
                  After cooperating with us, after paying us, we will help you
                  fulfill the order automatically and track every link in the
                  whole process, from purchasing, bargaining, quality
                  inspection, delivery, etc. If there are any abnormalities, we
                  will promptly report back to you.
                </div>
              </div>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="show10" id="ankleBottom_seven" class="ankleBottom">
              <div class="choose_img_left">
                <img src="../../assets/img/2-42.svg" alt="" />
              </div>
              <div class="choose_content_right">
                <div class="content_title">Worry-free after-sales</div>
                <!-- <div class="content_title2">24-hour billing number, 2-7 days after delivery</div> -->
                <div class="content_one">
                  <ul>
                    <li>Professional experienced team</li>
                    <li>Convenient Return & Refund</li>
                    <li>Fast handling of after-sales problems</li>
                    <li>Provide delivery proof for PayPal disputes</li>
                  </ul>
                </div>
                <!-- <div class="content_two">
                                Compared with Aliexpress, we directly cooperate with factories without paying platform commissions, so the
                                price is more competitive and cheaper.
                            </div> -->
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="bgEight">
      <div class="centeEight">
        <div class="workflow">
          <div class="workflow_top">
            <div class="workflow_title">How It Works</div>
            <div class="workflow_content">You sell, We ship well</div>
          </div>
          <div class="workflow_bottom">
            <div class="workflow_contact">
              <img class="contact_img" src="../../assets/img/2-31.svg" alt="" />
              <div class="contact_content">Contact Us</div>
            </div>
            <div class="arrows_one">
              <img class="arrows_img1" src="../../assets/img/2-30.svg" alt="" />
            </div>
            <div class="workflow_pay">
              <img class="pay_img" src="../../assets/img/2-32.svg" alt="" />
              <div class="pay_content">Pay Us</div>
            </div>
            <div class="arrows_two">
              <img class="arrows_img2" src="../../assets/img/2-30.svg" alt="" />
            </div>
            <div class="workflow_convey">
              <img class="convey_img1" src="../../assets/img/2-33.svg" alt="" />
              <!-- <img class="convey_img2" src="../../assets/img/2-14.png" alt=""> -->
              <div class="convey_content">We ship to your customer</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgNine">
      <div class="centeNine">
        <div class="foot">
          <div class="footOne">
            <img src="../../assets/img/logo1.svg" alt="" />
            <div class="webfba">
              Webfba – 
We are the All-In-One Dropshipping agent who helps you source and ship anything you need, such as general cargo, liquid, sensitive cargo, what more, we also offer POD service, One-piece also can be customized.
            </div>
          </div>
          <div class="footTwo">
            <div class="footTwoTitle">What we offer</div>
            <div class="footTwoContent">
              <ul>
                <!-- <li class="about-us" @click="abous">
                  <a href="javascript:void(0)">About Us</a>
                </li> -->
                <li @click="scrollTo(3)">Services</li>
                <li @click="scrollTo(4)">POD</li>
                <li @click="product">Product</li>
                <li @click="scrollTo(6);changeShow6();">Price</li>
                <li @click="
                  scrollTo(6);
                  changeShow8();
                ">Delivery </li>
                <li @click="
                  scrollTo(6);
                  changeShow8();
                ">Time</li>
                <li @click="scrollTo(8)">Processing</li>
              </ul>
            </div>
          </div>
          <div class="footThree">
            <div class="footThreeTitle">Our Company</div>
            <div class="footThreeContent">
              <ul>
                <li  @click="abous">About Us</li>
                <li @click="scrollTo(6);">Why Us？</li>
                <el-button
                  class="contact"
                  type="text"
                  @click="contact_us"
                  ><li class="contact_us">Contact Us</li></el-button
                >
              </ul>
            </div>
          </div>
          <div class="footFour">
            <!-- <div class="footFourTitle">Need help?</div>
            <div class="footFourContent">
              <ul>
                <el-button
                  class="contact"
                  type="text"
                  @click="centerDialogVisible = true"
                  ><li class="contact_us">Contact Us</li></el-button
                >

                <li>Help Center</li>
                <li>FAQs</li>
              </ul>
            </div> -->
            <!-- 点击底部contact us弹窗 邮箱链接-->
            <el-dialog
              title="Contact US"
              :visible.sync="centerDialogVisible"
              width="40%"
              center
            >
              <a
                href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=support@webfba.com"
                style="float: left"
                ><div
                  style="
                    float: left;
                    display: inline;
                    font-size: 2.5rem;
                    line-height: 4rem;
                  "
                >
                  click:
                </div>
                <img
                  src="../../assets/img/logo_gmail.png"
                  alt=""
                  style="width: 10rem; height: 4rem; float: right"
              /></a>
              <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
                <!-- <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button> -->
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <!-- 返回顶部 -->
    <el-backtop class="backtop" :right="34"></el-backtop>
  </div>
</template>

<script>
import Bus from '../../assets/js/bus';

export default {
  name: "Index",
  data() {
    return {
      show1: true,
      show2: false,
      show3: false,
      show4: true,
      show5: false,
      show6: false,
      show7: false,
      show8: false,
      show9: false,
      show10: false,
      titleShow: false,
      centerDialogVisible: false,
      active: 0, // 锚点当前激活的导航索引
    };
  },

  mounted() {
    //   wow动画初始化
    this.$nextTick(() => {
      this.$wow.init();
    });

    //   bgTwo和（多个动画）模块进入页面时是隐藏的,页面加载完变显示,有过渡动画
    this.titleShow = true;
    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll, false);
    
    // about us底部按键传值
    Bus.$on('services', services => {  
       setTimeout(()=>{
            this.scrollTo(services);
      },100)
            
        }); 
  },

  destroy() {
    // 必须移除监听器,不然当该vue组件被销毁了,监听器还在就会出错
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(".content_main div");
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop);
      });
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义当前点亮的导航下标
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      this.active = navIndex;
    },
    // 跳转到指定索引的元素
    scrollTo(index) {
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数,我们是从 0 开始,所以要 +1
      const targetOffsetTop = document.querySelector(
        `.content_main div:nth-child(${index + 1})`
      ).offsetTop;
      // 获取当前 offsetTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义一次跳 50 个像素,数字越大跳得越快,但是会有掉帧得感觉,步子迈大了会扯到蛋
      const STEP = 50;
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp();
      } else {
        // 往下滑
        smoothDown();
      }
      // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点,目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop - 200;
          // 关于 requestAnimationFrame 可以自己查一下,在这种场景下,相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown);
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop - 200;
          requestAnimationFrame(smoothUp);
        }
      }
    },

    changeShow1() {
      this.show1 = true;
      this.show2 = false;
      this.show3 = false;
    },
    changeShow2() {
      this.show1 = false;
      this.show2 = true;
      this.show3 = false;
    },
    changeShow3() {
      this.show1 = false;
      this.show2 = false;
      this.show3 = true;
    },
    changeShow4() {
      this.show4 = true;
      this.show5 = false;
      this.show6 = false;
      this.show7 = false;
      this.show8 = false;
      this.show9 = false;
      this.show10 = false;
    },
    changeShow5() {
      this.show4 = false;
      this.show5 = true;
      this.show6 = false;
      this.show7 = false;
      this.show8 = false;
      this.show9 = false;
      this.show10 = false;
    },
    changeShow6() {
      this.show4 = false;
      this.show5 = false;
      this.show6 = true;
      this.show7 = false;
      this.show8 = false;
      this.show9 = false;
      this.show10 = false;
    },
    changeShow7() {
      this.show4 = false;
      this.show5 = false;
      this.show6 = false;
      this.show7 = true;
      this.show8 = false;
      this.show9 = false;
      this.show10 = false;
    },
    changeShow8() {
      this.show4 = false;
      this.show5 = false;
      this.show6 = false;
      this.show7 = false;
      this.show8 = true;
      this.show9 = false;
      this.show10 = false;
    },
    changeShow9() {
      this.show4 = false;
      this.show5 = false;
      this.show6 = false;
      this.show7 = false;
      this.show8 = false;
      this.show9 = true;
      this.show10 = false;
    },
    changeShow10() {
      this.show4 = false;
      this.show5 = false;
      this.show6 = false;
      this.show7 = false;
      this.show8 = false;
      this.show9 = false;
      this.show10 = true;
    },
    // 跳转到关于公司
    abous() {
      this.$router.push({ path: "/Abous_us" });
    },
    product() {
      this.$router.push({ path: "/products" });
    },
    contact_us() {
      this.$router.push({ path: "/contact_us" });
    },
  },
};
</script>

<style lang='stylus' scoped>
@font-face {
  font-family: 'iconfont';
  src: url('../../assets/iconfont/iconfont.eot');
  src: url('../../assets/iconfont/iconfont.eot?#iefix') format('embedded-opentype'), url('../../assets/iconfont/iconfont.woff2') format('woff2'), url('../../assets/iconfont/iconfont.woff') format('woff'), url('../../assets/iconfont/iconfont.ttf') format('truetype'), url('../../assets/iconfont/iconfont.svg#iconfont') format('svg');
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.content_main {
  width: 100%;
  height: 100%;
  font-size: 62.5%;
  min-width: 127rem;

  .backtop {
    background-color: #aca4a4;
  }

  .bgOne {
    width: 100%;
    height: 10rem;
    position: fixed;
    top: 0px;
    z-index: 9999;
    // backdrop-filter: saturate(180%) blur(6px);
    background-color: rgba(7, 17, 27, 0.5);
    // filter: opacity(.3);
    background-color: var(--header-background);
    background-color: #FFFFFF;
    box-shadow: 3rem 0px 4rem #EEE;

    // background-image: linear-gradient(#ff7300, #FFFF);
    .centerOne {
      width: 120rem;
      margin: 0 auto;

      // background-color: greenyellow;
      .head {
        .firmlogo {
          float: left;
          width: 30.2rem;
          height: 8.1rem;
          margin-top: 1rem;

          .firmlogoright {
            float: left;
            width: 26.1rem;
            height: 8.1rem;
            margin-left: -4rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .topright {
          float: right;
          margin-top: 3.1rem;

          .selectleft {
            width: 6 0rem;
            float: left;

            span {
              display: inline-block;
              font-size: 1.6rem;
              color: #333333;
              margin-left: 4rem;
              font-weight: bold;
              line-height: 4rem;
            }

            // .onespan {
            // margin-left: 0;
            // }
            span:hover {
              color: #FF7300;
            }
          }

          .selectright {
            float: right;
            // margin-top:0.5rem;
            background-color: #FF7300;
            border-radius: 0.2rem;
            margin-left: 4rem;
            width: 14rem;
            height: 4rem;
            font-weight: 10rem;

            div {
              text-decoration: none;

              span {
                display: block;
                color: #FFFFFF;
                font-size: 1.6rem;
                text-align: center;
                font-weight: bold;
                line-height: 4rem;
              }
            }

            span:hover {
              color: #333333;
            }
          }
        }
      }
    }
  }

  .bgTwo {
    width: 100%;
    height: 80rem;

    // background: #F8F9FB;
    .centerTwo {
      width: 120rem;
      height: 80rem;
      margin: 0 auto;

      .bodymainone {
        float: left;
        width: 100%;
        // height: 50rem;
        // background-color: yellowgreen;
        margin-top: 6rem;

        .nick {
          float: left;
          width: 100%;

          // background: #F8F9FB;
          // padding-bottom: 6.5rem;
          .titletop {
            position: relative;
            margin-top: 8.9rem;

            .titleleft {
              float: left;
              width: 45rem;
              height: 27.2rem;

              .titleone {
                font-size: 5rem;
                color: #333333;
                display: inline-block;
                font-weight: 900;
                line-height: 6rem;
                // font-family:Ink Free;
              }

              .middleOne {
                display: inline-block;
                font-size: 6rem;
                font-weight: 900;
                color: #FF7300;
                line-height: 7rem;
              }

              .middleTwo {
                display: inline-block;
                font-size: 6rem;
                font-weight: 900;
                color: #FF7300;
              }

              .middleThree {
                display: inline-block;
                font-size: 1.6rem;
                font-weight: 400;
                color: #999999;
                margin-top: 2.5rem;
              }
            }

            .titleright {
              float: right;
              width: 65rem;
              height: 38rem;

              // background-color: yellowgreen;
              .video {
                width: 100%;
              }
            }

            .bounce-enter-active {
              animation: bounce-in 0.5s;
            }

            .bounce-leave-active {
              animation: bounce-in 0.5s reverse;
            }

            @keyframes bounce-in {
              0% {
                transform: scale(0);
              }

              50% {
                transform: scale(1.3);
              }

              100% {
                transform: scale(1);
              }
            }
          }

          .titleBottom {
            float: left;
            margin-top: 10rem;
            position: relative;

            .subtitleOne {
              width: 34.5rem;
              height: 13rem;
              float: left;
              background-color: #FFFFFF;
              position: relative;
              box-shadow: #eeeeee 0rem 0rem 1rem 0.5rem;

              span:first-child {
                display: inline-block;
                font-weight: 600;
                font-size: 2rem;
                color: #333333;
                margin-top: 1.5rem;
                margin-left: 2rem;
              }

              span:nth-child(2) {
                display: inline-block;
                color: #333333;
                font-size: 1.6rem;
                margin-top: 0.5rem;
                margin-left: 2rem;
              }

              .imgOne {
                position: absolute;
                width: 8.4rem;
                height: 8.4rem;
                border-radius: 4.2rem;
                right: -4.2rem;
                top: -4.2rem;
              }
            }

            .subtitleTwo {
              width: 34.5rem;
              height: 13rem;
              float: left;
              background-color: #FFFFFF;
              position: relative;
              margin-left: 6.5rem;
              box-shadow: #eeeeee 0rem 0rem 1rem 0.5rem;

              span:first-child {
                display: inline-block;
                font-size: 2rem;
                color: #333333;
                font-weight: 600;
                margin-top: 1.5rem;
                margin-left: 2rem;
              }

              span:nth-child(2) {
                display: inline-block;
                color: #333333;
                font-size: 1.6rem;
                margin-top: 0.5rem;
                margin-left: 2rem;
              }

              .imgTwo {
                position: absolute;
                width: 8.4rem;
                height: 8.4rem;
                border-radius: 4.2rem;
                right: -4.2rem;
                top: -4.2rem;
              }
            }

            .subtitleThree {
              position: relative;
              width: 34.5rem;
              height: 13rem;
              float: left;
              background-color: #FFFFFF;
              margin-left: 6.5rem;
              box-shadow: #eeeeee 0rem 0rem 1rem 0.5rem;
              box-sizing: border-box;
              padding-right: 0.2rem;

              span:first-child {
                display: inline-block;
                font-size: 2rem;
                color: #333333;
                font-weight: 600;
                margin-top: 1.5rem;
                margin-left: 2rem;
              }

              span:nth-child(2) {
                display: inline-block;
                color: #333333;
                font-size: 1.6rem;
                margin-top: 0.5rem;
                margin-left: 2rem;
              }

              .imgThree {
                position: absolute;
                width: 8.4rem;
                height: 8.4rem;
                border-radius: 4.2rem;
                right: -4.2rem;
                top: -4.2rem;
              }
            }
          }
        }
      }
    }
  }

  .bgThree {
    width: 100%;
    margin-top: 5rem;
    background-color: #f5f5f7;
    height: 15rem;

    .centeThree {
      width: 120rem;
      margin: 0 auto;

      .chest {
        float: left;

        .chestTop {
          width: 120rem;
          margin: auto;
          text-align: center;

          span {
            display: block;
            margin: auto;
            font-size: 4rem;
            color: #2F2E41;
            font-weight: 900;
            margin-top: 5rem;
          }
        }

        .chestButtom {
          width: 120rem;
          margin-top: 5rem;
          text-align: center;

          div {
            display: inline-block;
            padding-bottom: 2rem;
            margin-left: 5rem;
            border-bottom: #FFFFFF solid 0.2rem;

            span {
              display: inline-block;
              font-weight: 400;
              font-size: 1.8rem;
              color: #333333;
            }

            span:hover {
              color: #FF7300;
            }
          }

          div:first-child {
            margin-left: 0;
          }

          div:hover {
            border-bottom: #FF7300 solid 0.2rem;
          }
        }
      }
    }
  }

  #bgFour {
    float: left;
    width: 100%;
    padding-bottom: 7rem;
    background-color: #f5f5f7;

    .centeFour {
      width: 120rem;
      margin: 0 auto;

      .abdomen {
        .abdomenTop {
          float: left;
          width: 100%;
          margin-top: 3rem;

          .abdomenOne {
            float: left;
            width: 39rem;
            height: 21rem;
            // background-color: yellowgreen;
            background-color: #FFFFFF;
            position: relative;

            .imgOne {
              width: 8rem;
              height: 7.5rem;
              margin: auto;
              margin-top: 3.7rem;

              img {
                width: 100%;
                height: 100%;
              }
            }

            // div:nth-child(2) {
            // display: visible;
            // background-color: #FE7201;
            // position: absolute;
            // width: 6rem;
            // height: 6rem;
            // border-radius: 3rem;
            // right: -3rem;
            // top: -3rem;
            // font-size: 3rem;
            // text-align: center;
            // line-height: 6rem;
            // color: #FFFFFF;
            // font-style: italic;
            // }
            div:nth-child(2) {
              font-size: 2rem;
              color: #333333;
              font-weight: 400;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenTwo {
            float: left;
            width: 39rem;
            height: 21rem;
            // background-color: yellowgreen;
            background-color: #FFFFFF;
            position: relative;
            margin-left: 1.5rem;

            .imgTwo {
              width: 8rem;
              height: 7.5rem;
              margin: auto;
              margin-top: 3.7rem;

              img {
                width: 85%;
                height: 100%;
              }
            }

            // div:nth-child(2) {
            // display: visible;
            // background-color: #FE7201;
            // position: absolute;
            // width: 6rem;
            // height: 6rem;
            // border-radius: 3rem;
            // right: -3rem;
            // top: -3rem;
            // font-size: 3rem;
            // text-align: center;
            // line-height: 6rem;
            // color: #FFFFFF;
            // font-style: italic;
            // }
            div:nth-child(2) {
              font-size: 2rem;
              color: #333333;
              font-weight: 400;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenThree {
            float: right;
            width: 39rem;
            height: 21rem;
            background-color: #FFFFFF;
            position: relative;

            .imgThree {
              width: 8rem;
              height: 7.5rem;
              margin: auto;
              margin-top: 3.7rem;

              img {
                width: 85%;
                height: 100%;
              }
            }

            // div:nth-child(2) {
            // display: visible;
            // background-color: #FE7201;
            // position: absolute;
            // width: 6rem;
            // height: 6rem;
            // border-radius: 3rem;
            // right: -3rem;
            // top: -3rem;
            // font-size: 3rem;
            // text-align: center;
            // line-height: 6rem;
            // color: #FFFFFF;
            // font-style: italic;
            // }
            div:nth-child(2) {
              font-size: 2rem;
              color: #333333;
              font-weight: 400;
              text-align: center;
              margin-top: 3rem;
            }
          }
        }

        .abdomenMiddle {
          float: left;
          width: 100%;
          margin-top: 1.5rem;

          .abdomenFour {
            float: left;
            width: 39rem;
            height: 21rem;
            // background-color: yellowgreen;
            background-color: #FFFFFF;
            position: relative;

            .imgFour {
              width: 8rem;
              height: 7.5rem;
              margin: auto;
              margin-top: 3.7rem;

              img {
                width: 100%;
                height: 100%;
              }
            }

            // div:nth-child(2) {
            // display: visible;
            // background-color: #FE7201;
            // position: absolute;
            // width: 6rem;
            // height: 6rem;
            // border-radius: 3rem;
            // right: -3rem;
            // top: -3rem;
            // font-size: 3rem;
            // text-align: center;
            // line-height: 6rem;
            // color: #FFFFFF;
            // font-style: italic;
            // }
            div:nth-child(2) {
              font-size: 2rem;
              color: #333333;
              font-weight: 400;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenFive {
            float: left;
            width: 39rem;
            height: 21rem;
            // background-color: yellowgreen;
            background-color: #FFFFFF;
            position: relative;
            margin-left: 1.5rem;

            .imgFive {
              width: 8rem;
              height: 7.5rem;
              margin: auto;
              margin-top: 3.7rem;

              img {
                width: 100%;
                height: 100%;
              }
            }

            // div:nth-child(2) {
            // display: visible;
            // background-color: #FE7201;
            // position: absolute;
            // width: 6rem;
            // height: 6rem;
            // border-radius: 3rem;
            // right: -3rem;
            // top: -3rem;
            // font-size: 3rem;
            // text-align: center;
            // line-height: 6rem;
            // color: #FFFFFF;
            // font-style: italic;
            // }
            div:nth-child(2) {
              font-size: 2rem;
              color: #333333;
              font-weight: 400;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenSix {
            float: right;
            width: 39rem;
            height: 21rem;
            background-color: #FFFFFF;
            position: relative;

            .imgSix {
              width: 8rem;
              height: 7.5rem;
              margin: auto;
              margin-top: 3.7rem;

              img {
                width: 100%;
                height: 100%;
              }
            }

            // div:nth-child(2) {
            // display: visible;
            // background-color: #FE7201;
            // position: absolute;
            // width: 6rem;
            // height: 6rem;
            // border-radius: 3rem;
            // right: -3rem;
            // top: -3rem;
            // font-size: 3rem;
            // text-align: center;
            // line-height: 6rem;
            // color: #FFFFFF;
            // font-style: italic;
            // display: none;
            // }
            div:nth-child(2) {
              font-size: 2rem;
              color: #333333;
              font-weight: 400;
              text-align: center;
              margin-top: 3rem;
            }
          }
        }

        .abdomenButtom {
          float: left;
          width: 100%;
          margin-top: 1.5rem;

          .abdomenSeven {
            float: left;
            width: 39rem;
            height: 21rem;
            // background-color: yellowgreen;
            background-color: #FFFFFF;
            position: relative;

            .imgSeven {
              width: 8rem;
              height: 7.5rem;
              margin: auto;
              margin-top: 3.7rem;

              img {
                width: 100%;
                height: 100%;
              }
            }

            // div:nth-child(2) {
            // display: visible;
            // background-color: #FE7201;
            // position: absolute;
            // width: 6rem;
            // height: 6rem;
            // border-radius: 3rem;
            // right: -3rem;
            // top: -3rem;
            // font-size: 3rem;
            // text-align: center;
            // line-height: 6rem;
            // color: #FFFFFF;
            // font-style: italic;
            // }
            div:nth-child(2) {
              font-size: 2rem;
              color: #333333;
              font-weight: 400;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenEight {
            float: left;
            width: 39rem;
            height: 21rem;
            // background-color: yellowgreen;
            background-color: #FFFFFF;
            position: relative;
            margin-left: 1.5rem;

            .imgEight {
              width: 8rem;
              height: 7.5rem;
              margin: auto;
              margin-top: 3.7rem;

              img {
                width: 100%;
                height: 100%;
              }
            }

            // div:nth-child(2) {
            // display: visible;
            // background-color: #FE7201;
            // position: absolute;
            // width: 6rem;
            // height: 6rem;
            // border-radius: 3rem;
            // right: -3rem;
            // top: -3rem;
            // font-size: 3rem;
            // text-align: center;
            // line-height: 6rem;
            // color: #FFFFFF;
            // font-style: italic;
            // }
            div:nth-child(2) {
              font-size: 2rem;
              color: #333333;
              font-weight: 400;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenNine {
            float: right;
            width: 39rem;
            height: 21rem;
            background-color: #FFFFFF;
            position: relative;

            .imgNine {
              width: 8rem;
              height: 7.5rem;
              margin: auto;
              margin-top: 3.7rem;

              img {
                width: 85%;
                height: 100%;
              }
            }

            // div:nth-child(2) {
            // display: visible;
            // background-color: #FE7201;
            // position: absolute;
            // width: 6rem;
            // height: 6rem;
            // border-radius: 3rem;
            // right: -3rem;
            // top: -3rem;
            // font-size: 3rem;
            // text-align: center;
            // line-height: 6rem;
            // color: #FFFFFF;
            // font-style: italic;
            // }
            div:nth-child(2) {
              font-size: 2rem;
              color: #333333;
              font-weight: 400;
              text-align: center;
              margin-top: 3rem;
            }
          }
        }
      }
    }
  }

  #bgFour_two {
    float: left;
    width: 100%;
    margin-top: 5rem;
    padding-bottom: 12rem;

    // display: none;
    .centeFour {
      width: 120rem;
      margin: 0 auto;

      .abdomen {
        .abdomenTop {
          float: left;
          width: 100%;

          .abdomenOne {
            float: left;
            width: 59.1rem;
            height: 36.5rem;
            // background-color: yellowgreen;
            box-shadow: #CCCCCC 0rem 0rem 1rem 0.5rem;
            position: relative;

            .imgOne {
              width: 48.8rem;
              height: 26.8rem;
              float: right;

              img {
                width: 100%;
                height: 100%;
              }
            }

            div:nth-child(2) {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenTwo {
            float: right;
            width: 59.1rem;
            height: 36.5rem;
            border-radius: 0.5rem;
            box-shadow: #CCCCCC 0rem 0rem 1rem 0.5rem;
            position: relative;

            .imgTwo {
              width: 48.8rem;
              height: 26.8rem;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            div:nth-child(2) {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              text-align: center;
              margin-top: 3rem;
            }
          }
        }

        .abdomenButtom {
          float: left;
          width: 100%;
          margin-top: 1.6rem;

          .abdomenSeven {
            float: left;
            width: 59.1rem;
            height: 36.5rem;
            border-radius: 0.5rem;
            box-shadow: #CCCCCC 0rem 0rem 1rem 0.5rem;
            position: relative;

            .imgSeven {
              width: 48.8rem;
              height: 26.8rem;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            div:nth-child(2) {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenEight {
            float: right;
            width: 59.1rem;
            height: 36.5rem;
            border-radius: 0.5rem;
            box-shadow: #CCCCCC 0rem 0rem 1rem 0.5rem;
            position: relative;

            .imgEight {
              width: 48.8rem;
              height: 26.8rem;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            div:nth-child(2) {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              text-align: center;
              margin-top: 3rem;
            }
          }
        }
      }
    }
  }

  #bgFour_three {
    float: left;
    width: 100%;
    margin-top: 5rem;
    padding-bottom: 12rem;

    // display: none;
    .centeFour {
      width: 120rem;
      margin: 0 auto;

      .abdomen {
        .abdomenTop {
          float: left;
          width: 100%;

          .abdomenOne {
            float: left;
            width: 58.98rem;
            height: 38.44rem;
            // background-color: yellowgreen;
            border-radius: 0.5rem;
            box-shadow: #CCCCCC 0rem 0rem 1rem 0.5rem;
            position: relative;

            .imgOne {
              width: 100%;
              height: 32rem;
              float: right;

              img {
                width: 100%;
                height: 100%;
              }
            }

            div:nth-child(2) {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenTwo {
            float: right;
            width: 58.98rem;
            height: 38.44rem;
            border-radius: 0.5rem;
            box-shadow: #CCCCCC 0rem 0rem 1rem 0.5rem;
            position: relative;

            .imgTwo {
              width: 100%;
              height: 32rem;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            div:nth-child(2) {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              text-align: center;
              margin-top: 3rem;
            }
          }
        }

        .abdomenButtom {
          float: left;
          width: 100%;
          margin-top: 1.6rem;

          .abdomenSeven {
            float: left;
            width: 38.79rem;
            height: 38.4rem;
            border-radius: 0.5rem;
            box-shadow: #CCCCCC 0rem 0rem 1rem 0.5rem;
            position: relative;

            .imgSeven {
              width: 100%;
              height: 26.6rem;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            div:nth-child(2) {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenEight {
            float: left;
            width: 38.79rem;
            height: 38.4rem;
            border-radius: 0.5rem;
            box-shadow: #CCCCCC 0rem 0rem 1rem 0.5rem;
            position: relative;
            margin-left: 1.8rem;

            .imgEight {
              width: 100%;
              height: 26.6rem;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            div:nth-child(2) {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              text-align: center;
              margin-top: 3rem;
            }
          }

          .abdomenNine {
            float: right;
            width: 38.79rem;
            height: 38.4rem;
            border-radius: 0.5rem;
            box-shadow: #CCCCCC 0rem 0rem 1rem 0.5rem;
            position: relative;

            .imgEight {
              width: 100%;
              height: 26.6rem;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            div:nth-child(2) {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              text-align: center;
              margin-top: 3rem;
            }
          }
        }
      }
    }
  }

  .bgFive {
    width: 100%;
    float: left;
    height: 73.2rem;

    .centeFive {
      width: 120rem;
      margin: 0 auto;

      .thigh {
        width: 100%;
        float: left;

        .product_title1 {
          font-size: 4rem;
          font-weight: 900;
          color: #333333;
          width: 100%;
          height: 10rem;
          text-align: center;
          line-height: 14rem;
        }

        .thighLeft {
          float: left;
          width: 45rem;
          height: 45rem;
          margin-top: 6.7rem;
          margin-left: 5rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .thighRight {
          float: right;
          width: 57rem;
          margin-top: 8.6rem;

          .thigh_content1 {
            float: left;
            width: 100%;
            height: 8rem;
            border-bottom: solid #F5F5F7 0.2rem;
            border-left: #FFFFFF solid 0.6rem;
            padding-top: 2.5rem;

            .square {
              float: left;
              width: 3rem;
              height: 3rem;
              margin-left: 3rem;

              .serve1 {
                font-size: 3.5rem;
                line-height: 3rem;
              }
            }

            .small_content1 {
              float: left;
              font-size: 2rem;
              color: #2F2E41;
              font-weight: 400;
              margin-left: 2.7rem;
              line-height: 4rem;
            }
          }

          .thigh_content1:hover {
            background-color: #F9F9F9;
            border-left: #FF7300 solid 0.6rem;
            color: #FF7300;
          }
        }
      }
    }
  }

  .bgSix {
    float: left;
    width: 100%;
    padding-bottom: 10.5rem;
    background-color: #F5F5F7;

    .centeSix {
      width: 120rem;
      margin: 0 auto;
      position: relative;

      .calfTop {
        text-align: center;
        margin-top: 6.9rem;
        color: #333333;
        font-size: 4rem;
        font-weight: 900;

        .calfTop_conten {
          font-size: 2.6rem;
          font-weight: 400;
        }
      }

      .calfButtom {
        margin-top: 4.5rem;

        .goods_top {
          width: 100%;
          height: 49.7rem;
          float: left;

          .goods_left {
            float: left;
            background-color: #FFFFFF;
            width: 33.2rem;
            height: 100%;

            .goods_title1 {
              float: left;
              width: 100%;
              text-align: center;
              font-size: 2.6rem;
              color: #333333;
              margin-top: 7.4rem;
              font-weight: bold;
            }

            .goods_one {
              width: 25rem;
              height: 25rem;
              margin: auto;
              margin-top: 17rem;

              img {
                float: left;
                width: 100%;
                height: 100%;
                transition: all 0.5s;
              }
            }

            .goods_one:hover img {
              transform: scale(1.2);
            }
          }

          .goods_middle {
            float: left;
            width: 43rem;
            height: 49.7rem;
            margin-left: 2rem;

            .goods_two {
              background-color: #FFFFFF;
              width: 100%;
              height: 23.92rem;
              float: left;

              .goods_two_left {
                float: left;
                width: 21.2rem;
                height: 10rem;
                margin-left: 5rem;
                margin-top: 7.9rem;

                .goods_title2 {
                  color: #333333;
                  font-size: 2.6rem;
                  font-weight: bold;
                  width: 100%;
                }

                .goods_two_content {
                  font-size: 1.6rem;
                  color: #333333;
                  width: 70%;
                  text-decoration: underline;
                  line-height: 3rem;
                }
              }

              .goods_two_right {
                float: right;
                width: 12.1rem;
                height: 15.8rem;
                margin-right: 4rem;
                margin-top: 4.1rem;

                img {
                  width: 100%;
                  height: 100%;
                  transition: all 0.5s;
                }
              }

              .goods_two_right:hover img {
                transform: scale(1.2);
              }
            }

            .goods_three {
              background-color: #FFFFFF;
              width: 100%;
              height: 23.92rem;
              float: left;
              margin-top: 1.86rem;

              .goods_three_left {
                float: left;
                width: 10.2rem;
                height: 10rem;
                margin-left: 5rem;
                margin-top: 7.9rem;

                .goods_title3 {
                  color: #333333;
                  font-size: 2.6rem;
                  font-weight: bold;
                  width: 100%;
                }

                .goods_three_content {
                  font-size: 1.6rem;
                  color: #333333;
                  width: 70%;
                  text-decoration: underline;
                  line-height: 3rem;
                }
              }

              .goods_three_right {
                float: right;
                width: 15rem;
                height: 15rem;
                margin-right: 4rem;
                margin-top: 4.1rem;

                img {
                  width: 100%;
                  height: 100%;
                  transition: all 0.5s;
                }
              }

              .goods_three_right:hover img {
                transform: scale(1.2);
              }
            }
          }

          .goods_right {
            float: right;
            background-color: #FFFFFF;
            width: 40rem;
            height: 100%;

            .goods_four_top {
              width: 80%;
              margin: auto;
              height: 5.1rem;
              margin-top: 6.7rem;

              .goods_title4 {
                color: #333333;
                font-size: 2.6rem;
                font-weight: bold;
                float: left;
                margin-top: 1rem;
              }

              .goods_center4 {
                color: #333333;
                font-size: 1.6rem;
                font-weight: 400;
                line-height: 3rem;
                float: right;
                width: 56%;
                text-decoration: underline;
              }
            }

            .goods_four {
              width: 25rem;
              height: 25rem;
              margin: 0 auto;
              margin-top: 6.7rem;

              img {
                width: 100%;
                height: 100%;
                transition: all 0.5s;
              }
            }

            .goods_four:hover img {
              transform: scale(1.2);
            }
          }
        }

        .goods_middle {
          width: 100%;
          height: 24.7rem;
          float: left;

          .goods_middle_five {
            background-color: #FFFFFF;
            width: 59.28rem;
            height: 23.92rem;
            float: right;
            margin-top: 1.86rem;

            .goods_five_left {
              float: left;
              width: 23.2rem;
              height: 10rem;
              margin-left: 8rem;
              margin-top: 4.7rem;

              .goods_five_title {
                color: #333333;
                font-size: 2.6rem;
                font-weight: bold;
                width: 100%;
              }

              .goods_five_content {
                font-size: 1.6rem;
                color: #333333;
                width: 34%;
                text-decoration: underline;
                line-height: 3rem;
              }
            }

            .goods_five_right {
              float: right;
              width: 20rem;
              height: 20rem;
              margin-right: 6rem;
              margin-top: 3rem;

              img {
                width: 100%;
                height: 100%;
                transition: all 0.5s;
              }
            }

            .goods_five_right:hover img {
              transform: scale(1.1);
            }
          }

          .goods_middle_six {
            background-color: #FFFFFF;
            width: 59.28rem;
            height: 23.92rem;
            float: left;
            margin-top: 1.86rem;

            .goods_six_left {
              float: left;
              width: 21.2rem;
              height: 10rem;
              margin-left: 8rem;
              margin-top: 4.7rem;

              .goods_six_title {
                color: #333333;
                font-size: 2.6rem;
                font-weight: bold;
                width: 100%;
              }

              .goods_six_content {
                font-size: 1.6rem;
                color: #333333;
                width: 20%;
                text-decoration: underline;
                line-height: 3rem;
              }
            }

            .goods_six_right {
              float: right;
              width: 20rem;
              height: 20rem;
              margin-right: 6rem;
              margin-top: 3rem;

              img {
                width: 100%;
                height: 100%;
                transition: all 0.5s;
              }
            }

            .goods_six_right:hover img {
              transform: scale(1.1);
            }
          }
        }

        .goods_bottom {
          width: 100%;
          height: 24.7rem;
          float: left;
          margin-top: 1rem;

          .goods_bottom_seven {
            background-color: #FFFFFF;
            width: 59.28rem;
            height: 23.92rem;
            float: right;
            margin-top: 1.86rem;

            .goods_seven_left {
              float: left;
              width: 21.2rem;
              height: 10rem;
              margin-left: 8rem;
              margin-top: 10.7rem;

              .goods_seven_title {
                color: #333333;
                font-size: 2.6rem;
                font-weight: bold;
                width: 100%;
              }
            }

            .goods_seven_right {
              float: right;
              width: 20rem;
              height: 20rem;
              margin-right: 6rem;
              margin-top: 3rem;

              img {
                width: 100%;
                height: 100%;
                transition: all 0.5s;
              }
            }

            .goods_seven_right:hover img {
              transform: scale(1.1);
            }
          }

          .goods_bottom_eight {
            background-color: #FFFFFF;
            width: 59.28rem;
            height: 23.92rem;
            float: left;
            margin-top: 1.86rem;

            .goods_eight_left {
              float: left;
              width: 22.2rem;
              height: 8rem;
              margin-left: 8rem;
              margin-top: 4.7rem;

              .goods_eight_title {
                color: #333333;
                font-size: 2.6rem;
                font-weight: bold;
                width: 100%;
              }

              .goods_eight_content {
                font-size: 1.6rem;
                color: #333333;
                width: 42%;
                text-decoration: underline;
                line-height: 3rem;
              }
            }

            .goods_eight_right {
              float: right;
              width: 20rem;
              height: 20rem;
              margin-right: 6rem;
              margin-top: 3rem;

              img {
                width: 100%;
                height: 100%;
                transition: all 0.5s;
              }
            }

            .goods_eight_right:hover img {
              transform: scale(1.1);
            }
          }
        }
      }
    }
  }

  .bgSeven {
    float: left;
    width: 100%;
    margin-top: 8rem;
    overflow: hidden;
    height: 67rem;

    .centeSeven {
      width: 120rem;
      margin: 0 auto;

      .ankle {
        .ankleTop {
          width: 100%;
          text-align: center;
          color: #333333;

          .ankleTop_title {
            font-size: 4rem;
            font-weight: 900;
          }

          .ankleTop_contnt {
            font-size: 2.6rem;
            font-weight: 400;
          }
        }

        .anklemiddle {
          width: 100%;
          display: inline-block;
          margin-top: 3.6rem;
          border-bottom: solid #dbdbe7 0.1rem;
          height: 10rem;

          .anklemiddleOne {
            float: left;
            width: 20rem;
            height: 10rem;
            text-align: center;
            font-size: 1.6rem;

            // border-bottom: #FF7300 solid 0.1rem;
            .choose_icon {
              font-size: 3rem;
            }

            span {
              display: inline-block;
            }
          }

          .anklemiddleOne1 {
            margin-left: 10rem;
          }

          .anklemiddleOne:hover {
            color: #FF7300;
            border-bottom: #FF7300 solid 0.1rem;
          }
        }

        // bgEight显示隐藏过渡动画
        .slide-fade-enter-active {
          transition: all 0.2s ease;
        }

        .slide-fade-leave-active {
          transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
        }

        /* .slide-fade-leave-active 用于 2.1.8 以下版本 */
        .slide-fade-enter, .slide-fade-leave-to {
          transform: translateX(10px);
          opacity: 0;
        }

        .ankleBottom {
          float: left;
          width: 100%;
          margin-top: 3rem;

          .choose_img_left {
            width: 72rem;
            height: 40rem;
            float: left;

            img {
              width: 100%;
              height: 100%;
              margin: auto;
              display: block;
              // margin-top: 6rem;
            }
          }

          .choose_img_left1 {
            width: 72rem;
            height: 40rem;
            float: left;

            img {
              width: 71%;
              height: 60%;
              // margin:  auto;
              display: block;
              margin-top: 6rem;
            }
          }

          .choose_content_right {
            width: 48rem;
            // height: 45rem;
            float: right;
            // padding: 3rem;
            margin-top: 5rem;
            box-sizing: border-box;

            .content_title {
              font-size: 3rem;
              color: #FF7300;
              font-weight: bold;
            }

            .content_title2 {
              font-size: 2rem;
              color: #FF7300;
              font-weight: bold;
              margin-top: 2rem;
            }

            .content_one {
              margin-top: 3rem;
              margin-bottom: 3rem;
              color: #333333;
              font-size: 2rem;
              line-height: 5rem;
              font-weight: 400;
              margin-left: 1.7rem;
            }

            .content_two {
              font-size: 1.6rem;
              font-weight: 400;
              color: #333333;
              line-height: 2.8rem;
            }
          }
        }

        #ankleBottom_one {
          // background-color: #F8F9FB;
        }

        #ankleBottom_two {
          // background-color: #F8F9FB;
        }

        #ankleBottom_three {
          // background-color: #F8F9FB;
        }

        #ankleBottom_four {
          // background-color: #F8F9FB;
        }

        #ankleBottom_five {
          // background-color: #F8F9FB;
          .content_one1 {
            margin-top: 3rem;
            margin-bottom: 3rem;
            color: #333333;
            font-size: 2rem;
            line-height: 5rem;
            font-weight: 400;
            margin-left: 1.7rem;
          }
        }

        #ankleBottom_six {
          // background-color: #F8F9FB;
        }

        #ankleBottom_seven {
          // background-color: #F8F9FB;
        }
      }
    }
  }

  .bgEight {
    width: 100%;
    height: 43rem;
    float: left;

    // margin-top: 5rem;
    // background-color:#F5F5F7;
    .centeEight {
      width: 120rem;
      margin: 0 auto;

      .workflow {
        .workflow_top {
          width: 33.6rem;
          height: 6.6rem;
          margin: 0 auto;
          text-align: center;

          .workflow_title {
            margin-top: 5.5rem;
            color: #333333;
            font-size: 4rem;
            font-weight: 900;
          }

          .workflow_content {
            color: #333333;
            font-size: 2rem;
            font-weight: 400;
          }
        }

        .workflow_bottom {
          width: 100%;
          height: 15.82rem;
          margin-top: 10rem;

          .workflow_contact {
            width: 31.1rem;
            height: 100%;
            float: left;
            box-shadow: #eeeeee 0rem 0rem 1rem 0.5rem;
            text-align: center;

            .contact_img {
              width: 7.3rem;
              height: 6.38rem;
              margin-top: 2.4rem;
            }

            .contact_content {
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              margin-top: 2rem;
            }
          }

          .arrows_one {
            width: 4.5rem;
            height: 3.8rem;
            float: left;
            margin-top: 6.31rem;
            margin-left: 4.1rem;

            .arrows_img1 {
              width: 100%;
            }
          }

          .workflow_pay {
            margin-left: 4.6rem;
            width: 31.1rem;
            height: 100%;
            float: left;
            box-shadow: #eeeeee 0rem 0rem 1rem 0.5rem;
            text-align: center;

            .pay_img {
              width: 7.3rem;
              height: 6.38rem;
              margin-top: 2.4rem;
            }

            .pay_content {
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              margin-top: 2rem;
            }
          }

          .arrows_two {
            width: 4.5rem;
            height: 3.8rem;
            float: left;
            margin-top: 6.31rem;
            margin-left: 4.1rem;

            .arrows_img2 {
              width: 100%;
            }
          }

          .workflow_convey {
            width: 31.1rem;
            height: 100%;
            float: right;
            box-shadow: #eeeeee 0rem 0rem 1rem 0.5rem;
            text-align: center;

            .convey_img1 {
              width: 7.3rem;
              height: 6.38rem;
              margin-top: 2.4rem;
            }

            .convey_content {
              font-size: 2rem;
              color: #18252D;
              font-weight: bold;
              margin-top: 2rem;
            }
          }
        }
      }
    }
  }

  .bgNine {
    float: left;
    width: 100%;
    height: 35rem;
    background-color: #18252D;
    margin-top: 9.4rem;

    .centeNine {
      width: 120rem;
      margin: 0 auto;

      .foot {
        .footOne {
          width: 40rem;
          // height: 5.2rem;
          float: left;
          margin-top: 6rem;

          img {
            width: 30%;
          }

          .webfba {
            color: #FFFFFF;
            font-size: 1.4rem;
            line-height: 3rem;
            font-weight: bold;
            display: inline-block;
          }
        }

        .footTwo {
          // widows: 100%;
          width: 13rem;
          float: left;
          margin-top: 6.7rem;
          margin-left: 20rem;

          .footTwoTitle {
            font-size: 1.8rem;
            color: #FF7300;
            font-weight: bold;
            float: left;
          }

          .footTwoContent {
            ul {
              margin: 0;
              padding: 0;

              li {
                widows: 100%;
                list-style: none;
                font-size: 1.4rem;
                color: #FFFFFF;
                line-height: 3rem;
                font-weight: bold;
                // display: inline-block;

                // a {
                //   color: #FFFFFF;
                // }

                // a:hover {
                //   color: #FF7300;
                // }
              }
              li:hover{
                  color: #FF7300;
                  cursor:pointer;
              }
            }
          }
        }

        .footThree {
          width: 20rem;
          float: left;
          margin-top: 6.7rem;
          margin-left: 25rem;

          .footThreeTitle {
            font-size: 1.8rem;
            color: #FF7300;
            font-weight: bold;
            float: left;
            width: 100%;
          }

          .footThreeContent {
            ul {
              margin: 0;
              padding: 0;

              li {
                width: 100%;
                list-style: none;
                font-size: 1.4rem;
                color: #FFFFFF;
                line-height: 3rem;
                font-weight: bold;
                display: inline-block;
              }
              li:hover{
                  color: #FF7300;
                  cursor:pointer;
              }
              .contact{
                  padding:0;
              }
            }
          }
        }

        /* .footFour {
          width: 10rem;
          float: right;
          margin-top: 6.7rem;

          .footFourTitle {
            font-size: 1.8rem;
            color: #FF7300;
            font-weight: bold;
            float: left;
            widows: 100%;
          }

          .footFourContent {
            ul {
              margin: 0;
              padding: 0;

              li {
                widows: 100%;
                list-style: none;
                font-size: 1.4rem;
                color: #FFFFFF;
                line-height: 3rem;
                font-weight: bold;
                display: inline-block;
              }

              .contact {
                padding: 0;
              }

              .contact_us:hover {
                color: #FF7300;
              }
            }
          }
        } */
      }
    }
  }
}
</style>
